"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for management user API calls.
 */
var UserMixin = /** @class */ (function () {
    function UserMixin() {
    }
    /**
     * User search query w/ limit
     * @param query
     * @param limit
     * @param contextAgencyId
     * @param callback
     */
    UserMixin.prototype.searchUsers = function (query, limit, contextAgencyId, callback) {
        var _this = this;
        var urlParams = {
            query: query,
            limit: limit,
            contextAgencyId: contextAgencyId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SearchUser.parse, 'warn'));
        };
        this.http.get('/users', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Retrieve agency users w/ pagination for a table
     * @param agencyId
     * @param limit
     * @param page
     * @param search
     * @param sortConfig
     * @param callback
     */
    UserMixin.prototype.getAgencyUsers = function (agencyId, limit, page, search, sortConfig, callback) {
        var _this = this;
        var urlParams = { limit: limit, page: page, sortBy: sortConfig.column, order: sortConfig.direction };
        if (search != null) {
            urlParams.search = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'clients', models_1.User.parse); }));
        };
        this.http.get("/agencies/".concat(agencyId, "/users"), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get a specific agency user
     * @param agencyId
     * @param userId
     * @param callback
     */
    UserMixin.prototype.getUser = function (agencyId, userId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullUser.parse));
        };
        this.http.get("/agencies/".concat(agencyId, "/clients/").concat(userId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Update a user's common info
     * @TODO Maybe want available for all APIs
     * @param userId
     * @param basicInfo
     * @param callback
     */
    UserMixin.prototype.updateUserInfo = function (userId, basicInfo, callback) {
        var _this = this;
        var body = {
            commonName: basicInfo.commonName,
            givenName: basicInfo.givenName,
            surname: basicInfo.surname,
            phone: basicInfo.phoneNumber,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/users/".concat(userId), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add a client to an agency by ID
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.addClientToAgency = function (agencyId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/".concat(agencyId, "/clients/").concat(clientId), null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a user and add them to an agency
     * @param agencyId
     * @param email
     * @param commonName
     * @param givenName
     * @param surname
     * @param phone
     * @param password
     * @param callback
     */
    UserMixin.prototype.createUserInAgency = function (agencyId, email, commonName, givenName, surname, phone, password, callback) {
        var _this = this;
        var body = {
            email: email,
            commonName: commonName,
            givenName: givenName,
            surname: surname,
            phone: phone,
            password: password,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullUser.parse));
        };
        this.http.post("/agencies/".concat(agencyId, "/users"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove a client from an agency
     * @param agencyId
     * @param clientId
     * @param notify
     * @param callback
     */
    UserMixin.prototype.removeClientFromAgency = function (agencyId, clientId, notify, callback) {
        var _this = this;
        var urlParams = { notify: notify.toString() };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/clients/").concat(clientId), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Force log-out an apparatus account by ID
     * @param apparatusId
     * @param callback
     */
    UserMixin.prototype.forceApparatusSignOut = function (apparatusId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/apparatus/".concat(apparatusId, "/devices"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get a client's external ID for an agency
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.getClientExternalId = function (agencyId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ClientExternalId.parse));
        };
        this.http.get("/agencies/".concat(agencyId, "/clients/").concat(clientId, "/external-link"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Set a client's external ID for an agency
     * @param agencyId
     * @param clientId
     * @param externalId
     * @param callback
     */
    UserMixin.prototype.setClientExternalId = function (agencyId, clientId, externalId, callback) {
        var _this = this;
        var body = {
            id: externalId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/".concat(agencyId, "/clients/").concat(clientId, "/external-link"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Promote a user to manager within an agency
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.promoteUserToManager = function (agencyId, clientId, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/".concat(agencyId, "/managers"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Demote a manager to a normal user in an agency
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.demoteManagerToUser = function (agencyId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/managers/").concat(clientId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Grant dispatch access to a normal user.
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.grantUserDispatch = function (agencyId, clientId, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/".concat(agencyId, "/dispatchers"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Revoke dispatch access from a normal user.
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.revokeUserDispatch = function (agencyId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/dispatchers/").concat(clientId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Grant SCU management access to a normal user.
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.grantUserSCUManagement = function (agencyId, clientId, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/".concat(agencyId, "/scu-managers"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Revoke SCU management access from a normal user.
     * @param agencyId
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.revokeUserSCUManagement = function (agencyId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/scu-managers/").concat(clientId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Retrieve the SMS registrations for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.getClientSMSRegistrations = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SMSRegistration.parse, 'warn'));
        };
        this.http.get("/clients/".concat(clientId, "/sms"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create an SMS registration for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param phone
     * @param callback
     */
    UserMixin.prototype.createClientSMSRegistration = function (clientId, phone, callback) {
        var _this = this;
        var body = {
            phone: phone,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SMSRegistration.parse));
        };
        this.http.post("/clients/".concat(clientId, "/sms"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove an SMS registration for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param registrationId
     * @param callback
     */
    UserMixin.prototype.removeClientSMSRegistration = function (clientId, registrationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/".concat(clientId, "/sms/").concat(registrationId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get email registrations for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.getClientEmailRegistrations = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.EmailRegistration.parse, 'warn'));
        };
        this.http.get("/clients/".concat(clientId, "/email"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create an email registration for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param email
     * @param callback
     */
    UserMixin.prototype.createClientEmailRegistration = function (clientId, email, callback) {
        var _this = this;
        var body = {
            email: email,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.EmailRegistration.parse));
        };
        this.http.post("/clients/".concat(clientId, "/email"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove an email registration for a client
     * @TODO Maybe want available for all APIs
     * @param clientId
     * @param registrationId
     * @param callback
     */
    UserMixin.prototype.removeClientEmailRegistration = function (clientId, registrationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/".concat(clientId, "/email/").concat(registrationId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Send a password reset email to a user
     * @TODO Should likely be in SupportMixin
     * @param clientId
     * @param callback
     */
    UserMixin.prototype.sendPasswordResetEmail = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/clients/".concat(clientId, "/password-reset"), null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return UserMixin;
}());
exports.default = UserMixin;
//# sourceMappingURL=UserMixin.js.map